import './common';
import guestUrls from "./routes/guest";
import {createApplication} from "./common.js";

const Application = createApplication(guestUrls);

Application.mount('#application');
